import React from 'react';
import { Flex } from 'rebass';

import { StyledExclamationMark } from '../../../components/icons';
import ColumnFilterSort from '../../../components/tableServerSide/ColumnFilterSort';

import { formatDateTimestamp } from '../../../util/date';

export const columnSortModifiersLinkedContracts = {
  sourceContractId: null,
  poNumber: null,
  beginDate: null,
  endDate: null,
  defaultSort: {}
};

export const columnFilterModifiersLinkedContracts = {
  poNumber: { expression: 'Like' },
  beginDate: { disabled: true },
  endDate: { disabled: true }
};

export const getLinkedContractsColumns = () => {
  return [
    {
      Header: tableInstance => (
        <ColumnFilterSort header='Contract Number' tableInstance={tableInstance} align='right' />
      ),
      accessor: 'sourceContractId',
      width: 150
    },
    {
      Header: tableInstance => <ColumnFilterSort header='PO Number' tableInstance={tableInstance} />,
      accessor: 'poNumber',
      width: 350
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Begin Date' tableInstance={tableInstance} />,
      accessor: 'beginDate',
      width: 120,
      Cell: ({ value }) => formatDateTimestamp(value)
    },
    {
      Header: tableInstance => <ColumnFilterSort header='End Date' tableInstance={tableInstance} />,
      accessor: 'endDate',
      width: 120,
      Cell: ({ value }) => formatDateTimestamp(value)
    },
    {
      Header: 'Exp',
      id: 'exp',
      accessor: 'endDate',
      width: 120,
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) => {
        const daysPrior = 10;
        const expirationDate = new Date(value);
        const thresholdDate = new Date(expirationDate.getTime() - daysPrior * 24 * 60 * 60 * 1000);

        return (
          new Date() > thresholdDate && (
            <Flex justifyContent='center' width='100%'>
              <StyledExclamationMark data-testid='exp-excl' />
            </Flex>
          )
        );
      }
    }
  ];
};
